// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabChatsSubTabs-modulelabel__DVXyN";
var _2 = "RequestProfileTabChatsSubTabs-modulesubTabs__u6OBN EntityTabSubTabs-moduleEntityTabSubTabs__c4_31";
export { _1 as "label", _2 as "subTabs" }
